import retailerSchema from './retailerSchema';

const responseRetailerSchema = [retailerSchema];

export default responseRetailerSchema;
